import Dexie from 'dexie';

export const db = new Dexie('MwanLocalDB');

db.version(1).stores({
    outbox: '++id, url, method, timestamp, status',
    api_snapshot: 'url, timestamp',
    form_definitions: 'formId, timestamp',
    dropdown_cache: 'url, timestamp',
    workflow_tasks: 'taskId, processInstanceId',
});

// v2: action-level queue for full-behavior replay (replays the thunk, not just the HTTP request)
db.version(2).stores({
    action_queue: '++id, actionName, timestamp, status',
});

export default db;
